import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lockedAccounts: [],
  loading: false,
  error: null,
  successMessage: null,
};

const accountManagementSlice = createSlice({
  name: 'accountManagement',
  initialState,
  reducers: {
    // Unlock account
    unlockAccount: (state) => {
      state.loading = true;
      state.error = null;
    },
    unlockAccountSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    unlockAccountFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch locked accounts
    fetchLockedAccounts: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLockedAccountsSuccess: (state, action) => {
      state.loading = false;
      state.lockedAccounts = action.payload;
      state.error = null;
    },
    fetchLockedAccountsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  unlockAccount,
  unlockAccountSuccess,
  unlockAccountFailure,
  fetchLockedAccounts,
  fetchLockedAccountsSuccess,
  fetchLockedAccountsFailure,
  clearError,
  clearSuccessMessage,
} = accountManagementSlice.actions;

// Selectors
export const selectLockedAccounts = (state) => state.accountManagement?.lockedAccounts || [];
export const selectAccountManagementLoading = (state) => state.accountManagement?.loading || false;
export const selectAccountManagementError = (state) => state.accountManagement?.error;
export const selectAccountManagementSuccessMessage = (state) => state.accountManagement?.successMessage;

export default accountManagementSlice.reducer;
